import { AnonymousLocationCookie, LocationSuggestion } from './LocationAutoSuggest.types';

export const LOCAL_STORAGE_KEY_LAST_SEARCHED_LOCATION = 'lastSearchedLocation';
export const NO_DEFAULT_LOCATION_COOKIE = 'noDefaultLocation';
export const LAST_LOCATION_ANONYMOUS_COOKIE = 'lastSearchedLocationAnonymous';
export const LAST_LOCATION_ANONYMOUS_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export type ResolveDefaultLocationInputs = {
  anonymousCookie: AnonymousLocationCookie | undefined;
  cachedLocalStorageSuggestion: LocationSuggestion | undefined;
  isLoggedIn: boolean;
  fetchUserLastLocation: (() => Promise<LocationSuggestion | undefined>) | undefined;
};

export async function resolveDefaultLocation(
  inputs: ResolveDefaultLocationInputs,
): Promise<LocationSuggestion | undefined> {
  if (inputs.anonymousCookie) {
    return {
      type: 'history',
      label: inputs.anonymousCookie.label,
      id: inputs.anonymousCookie.id,
    };
  }
  if (inputs.cachedLocalStorageSuggestion) {
    return inputs.cachedLocalStorageSuggestion;
  }
  if (inputs.isLoggedIn && inputs.fetchUserLastLocation) {
    return inputs.fetchUserLastLocation();
  }
  return undefined;
}
